import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import get from 'get-value';
import styled from 'styled-components';
import {moduleRoles} from '../../utils/roles';
import Loader from '../Loader';
import renaultCar from '../../images/car.png';
import SparePartsDomainContent from './SparePartsDomainContent';
import TechDocDomainContent from './TechDocDomainContent';
import ClaimsDomainContent from './ClaimsDomainContent';
import mainPageMessages from '../../intl/home/mainPageMessages';

const Img = styled.img`
    height: 35%;
    width: 35%;
`;
Img.displayName = 'Img';

class HomePage extends Component {
    render() {
        const {userDetail: {roles}, isLoadingSparePartsPreferences, isLoadingTechDocPreferences, isLoadingClaimsPreferences} = this.props;

        return <div className="container-fluid">
            <div className="row">
                <div className="col">
                    <h1 className="text-center"><FormattedMessage {...mainPageMessages.TITLE} /></h1>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="text-center pt-3">
                        <Img src={renaultCar}/>
                    </div>
                </div>
            </div>
            {
                <>
                    <div className="row pb-4">
                        {(moduleRoles.isDealerOrder(roles) || moduleRoles.isEditorOrder(roles) || moduleRoles.isSGEditorOrder(roles)) &&
                        <div className="col-12 col-lg-6">
                            {isLoadingSparePartsPreferences ? <Loader/> : <SparePartsDomainContent/>}
                        </div>
                        }
                        {(moduleRoles.isDealerDocumentation(roles) || moduleRoles.isEditorDocumentation(roles) || moduleRoles.isSGEditorDocumentation(roles)) &&
                        <div className="col-12 col-lg-6">
                            {isLoadingTechDocPreferences ? <Loader/> : <TechDocDomainContent/>}
                        </div>
                        }
                        {(moduleRoles.isDealerClaims(roles) || moduleRoles.isEditorClaims(roles)) &&
                        <div className="col-12 col-lg-6">
                            {isLoadingClaimsPreferences ? <Loader/> : <ClaimsDomainContent/>}
                        </div>
                        }
                    </div>
                </>
            }
        </div>
    }
}

const mapStateToProps = state => ({
    userDetail: state.profile.userDetail,
    isLoadingSparePartsPreferences: get(state, 'sparePartsPreferences.isLoading'),
    isLoadingTechDocPreferences: get(state, 'techDocPreferences.isLoading'),
    isLoadingClaimsPreferences: get(state, 'claimsPreferences.isLoading'),
});

export default connect(mapStateToProps, {})(HomePage);
